




import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import appointmentStatusesModel from "../models/appointment-status.model";

@Component({
  components: { EntityCrud },
})
export default class Specialties extends Vue {
  model: any = appointmentStatusesModel;

  title = "Tipos de Consulta";
  tableColumns = ["statusType", "name"];

  formColumns = ["statusType", "name"];
  defaultEntity = {  };
}
